/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionDefaultValues
 */
export interface SubscriptionDefaultValues {
    /**
     * zero or negative means there is no limit
     * @type {number}
     * @memberof SubscriptionDefaultValues
     */
    maxUsers?: number;
    /**
     * zero or negative means there is no limit
     * @type {number}
     * @memberof SubscriptionDefaultValues
     */
    maxIntegrations?: number;
    /**
     * zero or negative means there is no limit
     * @type {number}
     * @memberof SubscriptionDefaultValues
     */
    maxDomains?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionDefaultValues
     */
    dataUpdatesPerDay?: number;
}

/**
 * Check if a given object implements the SubscriptionDefaultValues interface.
 */
export function instanceOfSubscriptionDefaultValues(value: object): value is SubscriptionDefaultValues {
    return true;
}

export function SubscriptionDefaultValuesFromJSON(json: any): SubscriptionDefaultValues {
    return SubscriptionDefaultValuesFromJSONTyped(json, false);
}

export function SubscriptionDefaultValuesFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionDefaultValues {
    if (json == null) {
        return json;
    }
    return {
        
        'maxUsers': json['maxUsers'] == null ? undefined : json['maxUsers'],
        'maxIntegrations': json['maxIntegrations'] == null ? undefined : json['maxIntegrations'],
        'maxDomains': json['maxDomains'] == null ? undefined : json['maxDomains'],
        'dataUpdatesPerDay': json['dataUpdatesPerDay'] == null ? undefined : json['dataUpdatesPerDay'],
    };
}

export function SubscriptionDefaultValuesToJSON(json: any): SubscriptionDefaultValues {
    return SubscriptionDefaultValuesToJSONTyped(json, false);
}

export function SubscriptionDefaultValuesToJSONTyped(value?: SubscriptionDefaultValues | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'maxUsers': value['maxUsers'],
        'maxIntegrations': value['maxIntegrations'],
        'maxDomains': value['maxDomains'],
        'dataUpdatesPerDay': value['dataUpdatesPerDay'],
    };
}

